import React from 'react'
import { Typography, Box } from 'transfix-ui/core'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { TcmCard } from 'apps/marketplace/pages/spot-quote-tool/components/TcmCard'
import { IPriceRequestDetailsFragment } from 'apps/marketplace/pages/spot-quote-tool/graphql/PriceRequestDetailsFragment'
import { getCostStrategy } from 'apps/marketplace/pages/spot-quote-tool/utils/getCostStrategy'
import { ISpotRate } from 'apps/marketplace/store/amQuoting/types'
import { ICostControlConfig } from 'apps/spot-quote-control-panel/types/costControlConfig'
import { COST_STRATEGY } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { Card, CardHeader, brandColors } from 'transfix-ui'
import { formatAllInToDat, formatQuote } from '../../utils/formatFocusPanelContents'

// TODO - Remove this component entirely
interface ICostReferenceSectionProps {
  priceRequest: IPriceRequestDetailsFragment
  spotRate: Partial<ISpotRate> & { metadata: ISpotRate['metadata'] }
  appliedCostControlConfig?: ICostControlConfig | null
}

const useStyles = makeStyles(theme => ({
  cardRows: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '46px',
    alignItems: 'center',
    borderBottom: `1px solid ${brandColors.coolGray1}`,
  },
  bottomRow: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '46px',
    alignItems: 'center',
  },
  singleCard: {
    marginTop: theme.spacing(2),
    width: '49%',
  },
  text: {
    color: brandColors.coolGray5,
  },
}))

export function CostReferenceSection({
  appliedCostControlConfig,
  priceRequest,
  spotRate,
}: ICostReferenceSectionProps) {
  const classes = useStyles()
  const { pricingResponse } = priceRequest
  const { datRate, tcm25, tcm40, tcm50, tcm75 } = pricingResponse || {}
  const { adjustedCostBasis, dsCostPremiumPct, strategyChosen } = spotRate.metadata || {}

  const displayAdjustedCostBasis =
    getCostStrategy(strategyChosen, dsCostPremiumPct) !==
    COST_STRATEGY.defaultSpotControlPanelConfigs
      ? adjustedCostBasis
      : undefined

  return (
    <Box mt={4}>
      <Typography variant='subtitle1'>Cost Reference</Typography>
      <Box display='flex' gap={1} justifyContent='space-between'>
        <Card className={classes.singleCard}>
          <CardHeader>
            <Typography variant='overline'>DAT</Typography>
          </CardHeader>
          <div className={classes.cardRows}>
            <div className={classes.text}>DAT</div>
            <div>{formatQuote(pricingResponse?.datRate)}</div>
          </div>
          <div className={classes.cardRows}>
            <div className={classes.text}>All-In to Dat %</div>
            <div>{formatAllInToDat(priceRequest.premiums?.quoteWithFuel, datRate)}</div>
          </div>
          <div className={classes.cardRows}>
            <div className={classes.text}>High Dat</div>
            <div>{formatQuote(pricingResponse?.highDatRate)}</div>
          </div>
          <div className={classes.bottomRow}>
            <div className={classes.text}>Low Dat</div>
            <div>{formatQuote(pricingResponse?.lowDatRate)}</div>
          </div>
        </Card>
        <TcmCard
          tcm50={tcm50}
          tcm25={tcm25}
          tcm40={tcm40}
          tcm75={tcm75}
          allIn={priceRequest.premiums?.quoteWithFuel}
          appliedCostControlConfig={appliedCostControlConfig}
          className={classes.singleCard}
          adjustedCostBasis={displayAdjustedCostBasis}
        />
      </Box>
    </Box>
  )
}
